import React from 'react';
import option from './option.js'
import talk from './talk.js'
import secView from './secView'
import other from './other.js'
import sharePerson from './sharePerson.js'
import option2 from './options2.js' 

// import index_bg1 from './static/Home_page_bg01.png'
// import index_bg2 from  './static/Home_page_bg02.png'
// import index_bg3 from  './static/Home_page_left.png'
// import index_bg4 from  './static/Home_page_burble.png'
// import index_bg5 from  './static/Home_page_logo.png'

import main_01 from  './static/main_01.png'
import main_02 from  './static/main_02.png'
import main_03 from  './static/main_03.png'
import main_04 from  './static/main_04.png'
import main_05 from  './static/main_05.png'
import main_06 from  './static/main_06.png'
import main_07 from  './static/main_07.png'

import person1 from  './static/01anjianyuan.png'
import person2 from  './static/02zhanwuyuan.png'
import person3 from  './static/03liechesiji.png'
import person4 from  './static/04baojieyuan.png'
import person5 from  './static/05cheliangjianxiugong.png'
import person6 from  './static/06jiechuwanggong.png'
import person7 from  './static/07AFCjianxiugong.png'
import person8 from  './static/08diaoduzhongxinpiaowu.png'
import person9 from  './static/09tonghaojianxiugong.png'
import person10 from  './static/10quanmeitikefu.png'

import personbox_01 from  './static/01a.png'
import personbox_02 from  './static/02a.png'
import personbox_03 from  './static/03a.png'
import personbox_04 from  './static/04a.png'
import personbox_05 from  './static/05a.png'
import personbox_06 from  './static/06a.png'
import personbox_07 from  './static/07a.png'
import personbox_08 from  './static/08a.png'
import personbox_09 from  './static/09a.png'
import personbox_10 from  './static/10a.png'

import personbox2_01 from  './static/01b.png'
import personbox2_02 from  './static/02b.png'
import personbox2_03 from  './static/03b.png'
import personbox2_04 from  './static/04b.png'
import personbox2_05 from  './static/05b.png'
import personbox2_06 from  './static/06b.png'
import personbox2_07 from  './static/07b.png'
import personbox2_08 from  './static/08b.png'
import personbox2_09 from  './static/09b.png'
import personbox2_10 from  './static/10b.png'

import talk_01 from './static/talk_01.png'
import talk_02 from './static/talk_02.png'
import talk_03 from './static/talk_03.png'

import return_button from './static/return.png'
import miehuoqi from './static/miehuoqi.png'
import miehuoqi2 from './static/miehuoqi2.png'

import queue_01 from './static/queue_01.png'

import mp3_0 from './static/mp3/0.mp3'
// import mp3_1 from './static/mp3/1.mp3'
// import mp3_2 from './static/mp3/2.mp3'
// import mp3_6 from './static/mp3/6.mp3'

import map from './static/map.png'
import keyMap from './static/keyMap.png'

import share_bg from './static/share_bg.png'
import share_icon1 from './static/share_icon1.png'
import share_icon2 from './static/share_icon2.png'
import share_person1 from './static/share_person1.png'
import share_person2 from './static/share_person2.png'
import share_person3 from './static/share_person3.png'
import share_person4 from './static/share_person4.png'
import share_person5 from './static/share_person5.png'
import share_person6 from './static/share_person6.png'
import share_person7 from './static/share_person7.png'
import share_person8 from './static/share_person8.png'
import share_person9 from './static/share_person9.png'
import share_person10 from './static/share_person10.png'

import share_button from './static/share_button.png'

import say_jio from './static/say_jio.png'

import music from './static/music.png'

import xiaolaba from './static/xiaolaba.png'
import egg from './static/egg.png'
import click from './static/click.png'
import get from './static/get.png'

import type1 from './static/type1.png'
import type2 from './static/type2.png'


// const mp3 = [ mp3_0 , mp3_1 , mp3_2 , , , , mp3_6]

const main = [main_01, main_02 , main_03 , main_04 , main_05 , main_06 , main_07 ]

const personData = [ person1 , person2 , person3 , person4 , person5 , person6 , person7 , person8 , person9 , person10 ]

const personbox = [ personbox_01 , personbox_02,personbox_03,personbox_04,personbox_05,personbox_06,personbox_07,personbox_08,personbox_09 ,personbox_10 ]

const personbox2 = [ personbox2_01 , personbox2_02 , personbox2_03 , personbox2_04 , personbox2_05 , personbox2_06 , personbox2_07 , personbox2_08 , personbox2_09 , personbox2_10 ]

const talk_img = [talk_01 , talk_02 , talk_03 ]

const photos = [share_person1 , share_person2, share_person3 ,share_person4 ,share_person5 , share_person6 ,share_person7 ,share_person8 , share_person9 ,share_person10]


class App extends React.Component{

    state={
        eggFlag : false,
        playFlag: false,
        currerntIndex: 0,
        bgOpc:1,
        tapId: -1,
        isShowIndex: -1 ,
        sharePerson:[],
        person:[],
        talk:[],
        other:[],
        isShowMap: false,
        isShowKeyMap:false,
        share:false,
        queue1:{},
        fire:{},
        fingerFlag: false,
        fingerFlag2: false,
        fingerStyle:{
            x:-50,
            y:-50,
        },
        say:{
            word:'',
            isRight: false,
            right:0,
            left:0,
            transform:''
        },
        talks : [
            '请找到安检员，配合他完成安检任务',
            '请找到站务员，并引导乘客排队等候列车',
            '请找到列车司机，为旅客的出行保驾护航',
            '请找到地铁保洁员，配合她完成垃圾分类工作',
            '请找到车辆检修工，配合他完成灭火器检查工作',
            '请找到接触网检修工，配合他完成高压设备检查工作',
            '请找到通号检修工，了解郑州地铁购票方式',
            '请找到票卡管理员，了解车票价格',
            '请找到AFC检修工，了解他的工作内容',
            '请找到全媒体客服，了解郑州地铁资讯',
        ]
    }

    componentWillMount(){
        this.refs = []
        this.screenWidth = []
        this.isIpX = window.reSizeW === 812
        const defaultH = 1125
        const defaultWidthData = [3912,2121,3176,2065,3744,10536,3163]
        this.rate =  defaultH / window.reSizeH
        const actualWidthData = []
        defaultWidthData.forEach(item=>{
            actualWidthData.push(parseFloat((item / this.rate).toFixed(2)))
        })
        this.widths = actualWidthData
        this.handleOption()
        this.handlePerson()
        this.handlePersonTalk()
        this.handleSecView()
        this.handleOther()
        this.getScreenWidth()
        this.randEgg()
        // this.setState({ bgAudio:  mp3_1})
    }

    componentDidMount(){
        if(this.bgAudioCxt){
            this.bgAudioCxt.onload=()=>{
                this.bgAudioCxt.play()
            }
        }
        this.playAudio()
        this.playAudio3()
    }

    rand = (m,n)=> m+parseInt((n-m)*Math.random())

    randEgg = ()=>{
        const num = this.rand(50,1)
        if( num  ===  10 ){
            this.setState({ eggFlag:true })
        } 
    }

    playAudio = ()=>{
        const { playFlag } = this.state
        var audio = this.bgAudioCxt, play = ()=>{ if (!playFlag) {
            audio.play();
            this.setState({ playFlag: true })
        }};
        audio.play();
        document.addEventListener("WeixinJSBridgeReady", function () { play(); }, false);//微信
        document.addEventListener('YixinJSBridgeReady', function() {  play(); }, false); //易信
        // document.addEventListener("onload", function(e) { play(); }, false);
        window.onload = ()=>{ play() }
    }

    playAudio2 =()=>{
        let playFlag = true
        if(this.bgAudioCxt.paused){
            this.bgAudioCxt.play()
        } else {
            playFlag = false
            this.bgAudioCxt.pause()
        }
        this.setState({ playFlag })
    }

    playAudio3 = ()=>{
        if(window.wx){
            window.wx.config({
                debug: false,
                appId: '',
                timestamp: 1,
                nonceStr: '',
                signature: '',
                jsApiList: []
            });
            window.wx.ready(()=> {
                this.bgAudioCxt.play();
                this.setState({ playFlag: true })
            });
        }
    }

    handleOption = ()=>{

        const sharePerson_data =  JSON.parse(JSON.stringify(sharePerson))

        const fire = {
            width: this.getRateValue(260), 
            height: this.getRateValue(109),
            top:this.getRateValue(839),
            left:this.getRateValue(17918),
            img: miehuoqi
        }

        const state1 = {
            width: this.getRateValue(198), 
            height: this.getRateValue(193),
            img: type1
        }

        const state2 = {
            width: this.getRateValue(180), 
            height: this.getRateValue(157),
            img: type2
        }

        const queue1 = {               //  排队小人
            width: this.getRateValue(140),
            height: this.getRateValue(295),
            top: this.getRateValue(480),
            left: this.getRateValue(11774),
            img: queue_01
        }

        const data = JSON.parse(JSON.stringify(option))

        data.forEach((item,index)=>{
            item.id = index
            item.width = this.getRateValue(item.width)
            item.height = this.getRateValue(item.height)
            item.top = this.getRateValue(item.top)
            item.left = this.getRateValue(item.left) 
        })

        sharePerson_data.forEach((item,index)=>{
            item.id = index
            item.width = this.getRateValue(item.width ,4.2)
            item.height = this.getRateValue(item.height,4.2)
        })

        this.setState({ personData :  data , fire , queue1 ,sharePerson:sharePerson_data ,state1 ,state2})
    }

    handlePersonTalk = ()=>{

        const talk_data = JSON.parse(JSON.stringify(talk))

        talk_data.forEach((item,index)=>{
            item.id = index
            item.width = this.getRateValue(item.width)
            item.height = this.getRateValue(item.height)
            item.top = this.getRateValue(item.top)
            item.left = this.getRateValue(item.left) 
        })

        this.setState({ talk :  talk_data})
    }

    handleOther = ()=>{

        const other_data = JSON.parse(JSON.stringify(other))

        other_data.forEach((item,index)=>{
            item.id = index
            item.width = this.getRateValue(item.width , item.rate)
            item.height = this.getRateValue(item.height , item.rate)
            item.top = this.getRateValue(item.top )
            item.left = this.getRateValue(item.left) 
        })

        this.setState({ other :  other_data})
    }

    handleSecView = ()=>{
        const secView_data = JSON.parse(JSON.stringify(secView))

        secView_data.forEach((item,index)=>{

            item.forEach((it,i)=>{
                it.id = i
                if(it.width) it.width = this.getRateValue(it.width , it.rate)
                if(it.height) it.height = this.getRateValue(it.height , it.rate)
                if(it.top) it.top = this.getRateValue(it.top)
                if(it.left) it.left = this.getRateValue(it.left) 
            })

        })

        this.setState({ secView_data })

    }

    handlePerson = ()=>{
        const data = personbox.map((item,index)=>({
            img: item ,
            img2: personbox2[index],
            flag: false,        //  是否点亮
            isEvent : false,        //  是否触发事件
            event_End : false,          //  事件是否完成
            talk_index: option[index].talk_index,
            viewIndex: option[index].viewIndex
        }))
        this.setState({ person: data })
    }

    getRateValue = (value,speed)=> Number.parseFloat( (value / (speed || this.rate)).toFixed(2) )

    getScreenWidth = (index = 1)=>{
        this.widths.forEach( (it, i) => {
            if( index === i){
                let value = 0
                this.widths.forEach((v,j)=>{
                   if( j < index || j === 0 ){
                    value = value + v
                   }
                })
                this.screenWidth.push(value)
                if( index < this.widths.length -1 ){
                    this.getScreenWidth(index+1)
                }
            }
        })
    }

    onScroll = (e)=>{
        let { currerntIndex , bgOpc } = this.state
        const value =  e.currentTarget.scrollLeft;
        currerntIndex =  value > this.screenWidth[7] ? 7 : value > this.screenWidth[6] ? 7 :  value > this.screenWidth[5] ? 6 :  value > this.screenWidth[4] ? 5 :  value > this.screenWidth[3] ? 4 :  value > this.screenWidth[2] ? 3 :  value > this.screenWidth[1] ? 2 :  value > this.screenWidth[0] ? 1 : 0 
        bgOpc = (window.reSizeW - value) / window.reSizeW < 0 ? 0 :  (window.reSizeW - value) / window.reSizeW === 1 ? 1 : (window.reSizeW - value) / window.reSizeW / 3
        this.setState({ currerntIndex , bgOpc })
    }

    randomInt = (min, max) => Math.floor(Math.random() * (max - min) + min);

    getStyleH = ()=>({
        height: ( window.isRotate && window.reSizeW )|| window.reSizeH
    })

    getStyleW = ()=>({
        width:  ( window.isRotate && window.reSizeH )|| window.reSizeW
    })

    getPersonFrame = ()=>(

        this.state.person.map((item,index)=>( <img className="personbox person_a" ref={(e)=> this[`imgCxt_${index}`] = e} key={index} onClick={()=>this.tapPersoBox(index)} src={ item.event_End ? item.img2 : item.img} alt={index}/> ))
        
    )

    getContent = ()=>(

        main.map((item,index)=> ( <img  key={index} src={item} style={this.getStyleH()} alt={index} /> ) )

    )

    getPerson = ()=>{
        
        return this.state.personData.map((item,index) =>{

            return ( <img key={index} className="person_p2" src={personData[index]} style={{width:item.width , height: item.height , top: item.top , left: item.left , animationName: !personData[index].flag && (option2[index].ani || 'figerAni')  }} alt={item.name} /> )  

        })
    
    }

    getPerson2 = ()=>{

        const { personData } = this.state
        
        return option2.map((item,index) =>{

            return ( <img key={index} className="person_p" onClick={()=>{this.tapPerson(index)}} src={option2[index].img} style={{width:personData[index].width , height: personData[index].height , top: personData[index].top , left: personData[index].left , opacity: personData[index].opc || 1 ,  }} alt={item.name} /> )  

        })
    
    }

    getPersonTalkEl = ()=>(

        this.state.talk.map((item,index)=> <img key={index} className="person_p" src={talk_img[index]} style={{width:item.width , height: item.height , top: item.top , left: item.left ,opacity:item.opc }} alt="index"/> )

    )

    getlateXValue = (it)=> {
        if(it.width && it.width > window.reSizeW){
            return  this.isIpX ? `translateX(-${ (it.width - window.reSizeW) / 2 }px)` : `translateX(-${( it.width - window.reSizeW )* 0.56 }px)`
        } else {
            return  `translateX(0px)`
        }
    } 

    getShowBoxEl = ()=> {

        const { secView_data ,  isShowIndex  , fingerFlag2 } = this.state
        
        return isShowIndex !== 4 && secView_data.map((item,index)=>(

            this.state.isShowIndex === index &&  <div className="sec_view" key={index} >

                { isShowIndex === 0 && <div ref={e=>this.redbox = e} className="show_1_box" style={{right: this.isIpX ? '0.81rem' : '0.5rem'}} /> }

                { isShowIndex === 2 && <div ref={e=>this.leftbox = e} className="show_left_box" /> }

                { isShowIndex === 2 && <div ref={e=>this.rightbox = e} className="show_right_box" /> }

                { fingerFlag2 && <img className="finger" src={click} style={{transform: `translate(${this.state.fingerStyle.x}px,${this.state.fingerStyle.y}px)`}} alt=""/> } 

                {item.map((it,i)=>(
                    
                    ( it.bg &&

                        <img key={i} className="sec_view_bigImg" src={it.bg} onClick={()=>this.tapEventBg(index,i)} style={{width:it.width || window.reSizeW , height: it.height || '100%' ,zIndex:30 , transform: this.getlateXValue(it) }} alt={i}/>    

                    ) || (

                        ( 
                            it.event === 2 && <img key={i} ref={e => this[`ref_${index}_${i}`] = e} onTouchStart={(e)=>this.handleStart(index,i,e,it.x,it.y)} onTouchMove={(e)=>this.handleDrag(index,i,e,it.x,it.y,it.flag)} onTouchEnd={(e)=>this.onTouchEnd(index,i,it.x,it.y,it.position)}  className="sec_view_icon" src={it.icon} style={{width:it.width , height: it.height , top: it.top , left: it.left , transform: `translate(${it.x}px,${it.y}px)` , transition:it.ani && '1s ease' , opacity: it.opc }} alt={i}/>
                            
                        ) || (
                            
                            it.event === 1 && <img onClick={()=>this.tapEventClick(index,i)} className="sec_view_icon" key={i} src={it.icon} style={{width:it.width , height: it.height , top: it.top , left: it.left ,transition:it.ani && '2s ease'}} alt={i}/> 

                        )

                    )

                ))}

            </div>

        )) || this.getSecViewThr()

    }

    getSecViewThr = ()=>{
        const { secView_data , state1 , state2 } = this.state
        const data = secView_data[4]

        return (

            <div className="sec_view"  >

                <img className="sec_view_bigImg2" src={data[0].bg} alt={''} />   

                <div className="sec_view2">

                    {data.map((it,i)=>(

                        !it.bg && <div key={i} className="card_box">
                            
                            <img onClick={()=> this.tapCard(i) } className="sec_view_icon2"  src={it.icon} style={{width:it.width , height: it.height}} alt={i}/> 

                            { it.flag > 0 && it.flag === 1 && <img src={state1.img} className='type' style={{width:state1.width , height: state1.height}} alt=""/> } 

                            { it.flag > 0 && it.flag === 2 && <img src={state2.img} className='type' style={{width:state2.width , height: state2.height}} alt=""/> } 

                        </div>

                    ))}
                    
                </div> 

            </div>

        )
    }

    getFireEl = ()=>{

        const { fire } = this.state

        return <img  className="fire anistyle" src={fire.img} style={{width:fire.width , height: fire.height , top: fire.top , left: fire.left , animationName: 'figerAni'}} alt='fire' /> 
    
    }

    getFireEl2 = ()=>{

        const { fire } = this.state

        return <img onClick={ this.tapFire } className="fire" src={miehuoqi2} style={{width:fire.width , height: fire.height , top: fire.top , left: fire.left  }} alt='fire2' /> 
    
    }

    getQueue1 = ()=>{

        const { queue1 } = this.state

        return <img onClick={ this.tapQueue1 } ref={(e)=> this.queueCxt = e} className="fire" src={queue1.img} style={{width:queue1.width , height: queue1.height , top: queue1.top , left: queue1.left }} alt='fire' /> 
    
    }

    getShareEl = ()=> {

        const { sharePerson , person , tapShareFlag , eggFlag  } = this.state

        return ( <div className="sec_view"  >

            { eggFlag && <img src={egg} className="egg" alt="egg" onClick={ ()=> this.setState({ eggFlag : false }) } /> }

            <div className="share_box2" style={{width: this.isIpX ? '4.5rem' : '4.4rem'}}>

                { photos.map((item,index)=> person[index].event_End && 
                
                <img key={index} className="photo_box" src={item} style={{width: sharePerson[index].width, height: sharePerson[index].height , marginRight:this.isIpX ? '0.12rem' : '.1rem' }} alt={index}/> )  }

            </div>
            
            <img className="share_bg" src={share_bg} alt=""/>

            <img className="share_icon1" onClick={()=>this.setState({ tapShareFlag: true })} src={share_icon1} alt=""/>

            <img className="share_icon2" onClick={()=>this.setState({ share: false })} src={share_icon2} alt=""/>

            { tapShareFlag && <img className="xiaolaba" src={xiaolaba} alt=""/> }

            { tapShareFlag && <div className="black_bg" onClick={()=>this.setState({ tapShareFlag: false })} /> } 

        </div>)

    }

    getshareLeft = (index)=>{

        const isX = window.reSizeW === 812

        const size = isX ? 0.4 + 0.8 : 1

        return index+1 < 6 ? `${(index+1) * size}rem` : `${(index-5+1) * size}rem` 

    } 

    getshareTop = (index)=> {

        const isX = window.reSizeW === 812

        return  index+1 < 6 ? `0.8rem` : `${isX ? 1.85 : 2}rem` 

    } 

    getOtherEl = ()=> this.state.other.map((item,index)=> <div ref={(e)=> this[`otherCxt_${index}`] = e} onClick={()=>this.tapOtherIcon(index)} key={index} className="other_box" style={{width:item.width , height: item.height , top: item.top , left: item.left ,borderRadius: item.flag && '0rem' , animationName: item.flag && 'ani7' }}> { item.img && <img className="other_img" style={{width:item.width , height: item.height}} src={item.img} alt=""/>}  </div> ) 

    getSayEl = (index)=>{

        const { say } = this.state;

        return (

            <div className="talk" style={ {opacity: index > -1 ? 1 : 0, transform:`translateY(${index > -1 ? 0 : 300}%)` , letf: !say.isRight && 0 , right:say.isRight && 0 }  } >
                {say.word}
                <img src={say_jio} className="jio" style={{ left: say.left , right: say.right , transform: say.transform }} alt=""/>
            </div>

        ) 

    }

    tapCard = (index)=>{

        let { secView_data , person , tip2} = this.state , num = 0;

        if( secView_data[4][index].flag > 0 ) return 

        secView_data[4][index].flag =( (index === 3 || index === 5) && 2 )|| 1

        secView_data[4].forEach(item=>{ if(item.flag === 1) num++ })

        if( num === 4 ){
            person[6].flag = true
            person[6].event_End = true
            tip2 = '恭喜完成任务，继续收集图章吧！'
            this.setState({ person , tip2}, ()=> this.shuShowboxOrTip())
        }
        
        this.setState({ secView_data })

    }

    tapEventBg = (index)=>{
        if(index === 6){
            document.body.style.position = 'relative' 
            this.setState({ isShowMap: true })
        }
    }

    judgeDom1 = (index,i)=>{
        let { person , secView_data , tip2} = this.state
        const box = this.redbox.getBoundingClientRect()
        const criticalX = box.x - box.width
        const criticalY = box.y
        const ref = this[`ref_${index}_${i}`].getBoundingClientRect()

        this.safeNum = this.safeNum || []
        
        if( ref.x > criticalX && ref.y >  criticalY ){
            !this.safeNum.includes(i) &&  this.safeNum.push(i)
            secView_data[index][i].flag = false
            if( this.safeNum.length === secView_data[index].length - 1){
                person[index].isEvent = true
                person[index].event_End = true
                tip2 = '恭喜完成任务，继续收集图章吧！'
                this.setState({ person , tip2  }, ()=> this.shuShowboxOrTip() )
            }
            this.setState({ secView_data })
        }
    }

    judgeDom2 = (index,i,position)=>{
        let { person , secView_data , tip2} = this.state            // position 1 不可回收 左边  2可回收
        const leftbox = this.leftbox.getBoundingClientRect()
        const rightbox = this.rightbox.getBoundingClientRect()
        const ref = this[`ref_${index}_${i}`].getBoundingClientRect()

        const left = leftbox.bottom
        const right = rightbox.top

        this.rubbishNum = this.rubbishNum || []

        if( ( ref.y > right && position === 2 ) || ( ref.y < left && position === 1 ) ){
            !this.rubbishNum.includes(i) &&  this.rubbishNum.push(i)
            secView_data[index][i].flag = false
            secView_data[index][i].opc = 0
        } else {
            secView_data[index][i].x = 0
            secView_data[index][i].y = 0
        }

        if(this.rubbishNum.length === secView_data[2].length - 1){
            person[3].isEvent = true
            person[3].event_End = true
            tip2 = '恭喜完成任务，继续收集图章吧！'
            this.setState({ person , tip2 }, ()=> this.shuShowboxOrTip() )
        }

        this.setState({ secView_data })

    }

    onTouchEnd = (index,i,x,y,position)=>{
        document.body.removeEventListener('touchmove', this.mainMove, false );
        if( index === 0){
            this.judgeDom1(index,i)
        } else {
            this.judgeDom2(index,i,position)
        }
        this.setState({ fingerFlag2: false })
    }

    handleDrag = (index,i,e,x,y , flag)=>{

        if(!flag) return
        
        const { secView_data } = this.state

        const currentX = e.touches[0].clientY
        const currentY = e.touches[0].clientX
        // 
        const x2 = this.getRateValue(this[`startX_${index}_${i}`] - currentX - x , 2 )  
        const y2 = this.getRateValue(this[`startY_${index}_${i}`] - currentY + y ,2) 

        secView_data[index][i].x = -x2 
        secView_data[index][i].y = y2 

        this.setState({ secView_data })
    }

    handleStart = (index,i,e,x,y)=>{
        this[`startX_${index}_${i}`] = e.touches[0].clientY - x
        this[`startY_${index}_${i}`] = e.touches[0].clientX + y
        
        document.body.addEventListener('touchmove', this.mainMove, false);
    }

    mainMove = (e)=> e.preventDefault()

    tapOtherIcon = (index)=>{
        if( index === 1 ){
            document.body.style.position = 'relative'
            this.setState({ isShowKeyMap : true})
        } else{
            this.setState({ isShowIndex: 8 + index })
        }
    }

    tapEventClick = (index,i)=>{
        if(index === 3){
            this.tapBird(index,i)
        }
    }

    tapBird = (index,i)=>{
        let { secView_data , person , tip2} = this.state
        secView_data[index][i].top= window.reSizeW
        secView_data[index][i].left= 300
        person[5].event_End = true
        person[5].isEvent = true
        tip2 = '恭喜完成任务，继续收集图章吧！'
        this.setState({ secView_data , person , tip2},()=> this.shuShowboxOrTip())
    }

    tapPerson = (index)=>{

        let { person , isShowIndex , talk } = this.state

        const data = [ 7 , 8 , 9 , 2]

        // if(person[index].event_End) return
            
            person[index].flag = true     // 如果人物事件完成  图标点亮

        if( !person[index].talk_index ){
            
            isShowIndex = person[index].viewIndex  // 如果没有触发事件 并且不是直接对话的  显示二级

        } else {

            person[index].isEvent = true  // 对话者 直接显示触发对话事件

            talk[person[index].talk_index].opc = 1
            
        }

        if(data.includes(index)) person[index].event_End = true

        if( index === 1 ) this.setState({ fingerFlag: true , fingerStyle:{x: this.getRateValue(11820)  , y: this.getRateValue(580)} })
         
        if( index === 4 ) this.setState({ fingerFlag: true , fingerStyle:{x: this.getRateValue(18078)  , y: this.getRateValue(869)} })

        if( index === 0 && !person[index].isEvent ) this.setState({ fingerFlag2: true , fingerStyle:{x: this.getRateValue(1460)  , y: this.getRateValue(860)} })

        if( index === 3 && !person[index].isEvent ) this.setState({ fingerFlag2: true , fingerStyle: {x: window.reSizeW / 2 , y: window.reSizeH / 2} })

        this.setState({ person , isShowIndex , talk })

    }

    tapFire = ()=>{

        let { person } = this.state

        if( this.state.person[4].isEvent ){

            person[4].event_End = true

        }

        this.setState({ isShowIndex : 9  ,  fingerFlag : false})

    }

    tapQueue1 = async ()=>{

        let { person , queue1 , tip2 } = this.state

        if( this.state.person[1].isEvent ){

            queue1.top = this.getRateValue(640)

            await  this.setState({ queue1 })

            queue1.left = this.getRateValue(12190)

            await  this.setState({ queue1 })

            person[1].event_End = true

            tip2 = '恭喜完成任务，继续收集图章吧！'

            this.setState({ person , tip2 , fingerFlag : false } , this.shuShowboxOrTip)

        }

    }
 
    tapPersoBox = (index)=> {
        let { say } = this.state
        if( !this.state.person[index].event_End && !this.tapFlag){

            const ref = this[`imgCxt_${index}`].getBoundingClientRect()

            this.tapFlag = true
            this.timer = null
            clearTimeout(this.timer)

            say.isRight = (index+1)> 5
            say.right = (say.isRight && this[`imgCxt_${index}`].offsetParent.getBoundingClientRect().bottom - ref.top - ref.height) || null
            say.left = (!say.isRight &&  ref.bottom - ref.height) || null
            say.transform =( !say.isRight && 'scaleX(-1)' )|| 'scaleX(1)'
            say.word = this.state.talks[index]

            this.setState({ tapId : index , say },()=>
                this.timer = setTimeout(()=> {
                    this.tapFlag = null
                    this.setState({ tapId : -1 })
                },3500) 
            )

        }

    }

    tapGet = ()=> {
        document.body.style.position = 'fixed' ;
        this.setState({isShowKeyMap: false , isShowMap: false})
    }
        
    shutShowIndex = ()=> this.setState({ isShowIndex : -1 , fingerFlag2: false})

    shuShowboxOrTip = ()=> setTimeout(()=>this.setState({ tip2 : '' , isShowIndex: -1}),3500)

    render(){

        const { currerntIndex , isShowIndex , isShowMap , bgOpc , tip2 , share , person , tapId , playFlag ,isShowKeyMap , fingerStyle , fingerFlag , fingerFlag2 } = this.state

        let isShowShareButton = false 

        if( person.some(item=> item.event_End ) ) isShowShareButton = true

        return (

                <section>

                    { this.getSayEl(tapId) } 

                    { share && this.getShareEl() }

                    { <div className="tipp" style={{transform: `translateY(${tip2 ? 100 : -200}%)` , opacity: tip2 ? 1: 0 }} >{tip2}</div> }  

                    <div className="tip" style={{opacity: currerntIndex === 1 ? 1 : 0 , transform: `translateY(${currerntIndex === 1 ? 100 : -200}%)` }}>温馨提示：点击剪影，根据提示寻找工作人员，体验地铁服务</div>

                    <div className="showBox" style={{opacity: isShowIndex > -1 ? 1 : 0 , display: isShowIndex > -1 ? 'block' : 'none'}} > 

                        <img className="return_button" onClick={this.shutShowIndex} src={return_button} alt="return"/>

                        { this.getShowBoxEl() } 

                    </div>
                    
                    <img onClick={this.playAudio2} className='music' src={music} style={{ animation: playFlag && 'circle 1s infinite linear' }} alt=""/>

                    { (isShowMap || isShowKeyMap) && <div className="map_box_box">

                        {  <img src={get} className="get" onClick={()=> this.tapGet()} style={{left: isShowMap && '0.2rem' , right: isShowKeyMap && '0.2rem'}} alt="" />  } 

                        <div className="map_box">

                        { isShowMap && <img className="" style={{...this.getStyleH()}} src={map} alt=""/>  }

                        { isShowKeyMap && <img className="" style={{...this.getStyleH()}} src={keyMap} alt=""/> }

                        </div>

                    </div> }
                    
                    { isShowShareButton && currerntIndex > 0 && <img className="share_button" onClick={()=>this.setState({share: true})} src={share_button} alt=""/>  }      

                    <div className="person_imgs"  style={{...this.getStyleW(),opacity: currerntIndex ? 1 : 0 }} > 

                        { this.getPersonFrame() }

                    </div>
                
                    <section ref={(e)=> this.mainCxt = e } className="main" style={{...this.getStyleH()}} onScroll={this.onScroll}  >

                        { fingerFlag && <img className="finger" src={click} style={{transform: `translate(${fingerStyle.x}px,${fingerStyle.y}px)`}} alt=""/> } 

                        <audio id="bgAudio" ref={(e)=> this.bgAudioCxt = e} src={mp3_0} preload="auto" loop="loop" autoPlay="autoplay" />

                        {/* <img src={ index_bg2 } style={{opacity: bgOpc , display: (bgOpc && 'block') || 'none' , left: window.reSizeW / 2 }} className="main_head_content" alt="main_head_content" /> */}
                        
                        { this.getPerson() }

                        { this.getPerson2() }

                        { this.getPersonTalkEl() }

                        { this.getContent() }

                        { this.getFireEl() }

                        { this.getFireEl2() }

                        { this.getQueue1() }

                        { this.getOtherEl() }

                    </section>

                </section>

        )
    }

}



export default App;
